import { Component, Input } from '@angular/core';

@Component({
    selector: 'nuso-warning-box',
    templateUrl: './warning-box.component.html',
    styleUrls: ['./warning-box.component.scss'],
    standalone: false
})
export class WarningBoxComponent {
  constructor() {}
  @Input() warningList: string[];
}
